import type { ReactNode } from 'react';
import { Sparkles, Trash2, X } from 'lucide-react';
import { pickCss } from '@/shared/lib/css-utils';
import { Button, Heading, Text } from '@/shared/ui';
import css from './agent-drawer-header.module.scss';

const styles = pickCss(css, css.root);

export type AgentDrawerHeaderProps = {
  title: string;
  subtitle?: ReactNode;
  titleId?: string;
  onClose: () => void;
  // When supplied, renders a trash button next to the close button that
  // clears the current conversation. Hidden when the panel has no session
  // to clear so the header stays uncluttered in the empty state.
  onClear?: () => void;
};

export const AgentDrawerHeader = ({
  title,
  subtitle,
  titleId,
  onClose,
  onClear,
}: AgentDrawerHeaderProps) => (
  <header className={styles()}>
    <div className={css.titleRow}>
      <span aria-hidden="true" className={css.icon}>
        <Sparkles size={18} />
      </span>
      <div className={css.titleBlock}>
        <Heading as="h2" id={titleId} size="md">
          {title}
        </Heading>
        {subtitle &&
          (typeof subtitle === 'string' ? (
            <Text size="xs" variant="muted">
              {subtitle}
            </Text>
          ) : (
            subtitle
          ))}
      </div>
    </div>
    <div className={css.actions}>
      {onClear && (
        <Button
          aria-label="Clear conversation"
          icon={<Trash2 aria-hidden="true" size={18} />}
          onClick={onClear}
          size="icon"
          type="button"
          variant="ghost"
        />
      )}
      <Button
        aria-label="Close agent panel"
        icon={<X aria-hidden="true" size={18} />}
        onClick={onClose}
        size="icon"
        type="button"
        variant="ghost"
      />
    </div>
  </header>
);
